import { complaintsPolicyPath } from './complaints-policy';
import { howWeCompareAgentsPath } from './how-we-compare-agents';
import { privacyPolicyPath } from './privacy-policy';
import { termsOfUsePath } from './terms-of-use';

export type LegalLink = {
  label: string;
  path: string;
};

// Landlord terms are public but deliberately not linked from footers or the sitemap.
const footerLegalLinks = [
  { documentId: 'privacyPolicy', label: 'Privacy', path: privacyPolicyPath },
  { documentId: 'termsOfUse', label: 'Terms', path: termsOfUsePath },
  {
    documentId: 'howWeCompareAgents',
    label: 'How we compare agents',
    path: howWeCompareAgentsPath,
  },
  {
    documentId: 'complaintsPolicy',
    label: 'Complaints',
    path: complaintsPolicyPath,
  },
] as const;

export const footerLegalDocumentIds = footerLegalLinks.map(
  ({ documentId }) => documentId,
);

export const getFooterLegalLinks = (
  publishedDocumentIds: readonly string[],
): LegalLink[] => {
  const publishedIds = new Set(publishedDocumentIds);

  return footerLegalLinks
    .filter(({ documentId }) => publishedIds.has(documentId))
    .map(({ label, path }) => ({ label, path }));
};

export const getLegalDocumentPath = (documentId: string) =>
  footerLegalLinks.find((link) => link.documentId === documentId)?.path;
